module.exports = __webpack_public_path__ + "static/media/ajout-participant.37c68992.png";